module.exports = __webpack_public_path__ + "img/DNADamage-INCA_10X_IC.b799b6ea.png";